export default function WhatIsSection() {
  return (
    <section id="czym-jest" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            Podstawy
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-3xl mx-auto leading-relaxed">
            Kakobuy Spreadsheet to uporządkowana lista produktów, która pomaga użytkownikom znaleźć najlepsze produkty z chińskich platform zakupowych. To nie zwykły arkusz – to kompleksowe narzędzie, które łączy w sobie bazę danych produktów, poradnik zakupowy i system weryfikacji jakości.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
          <div className="rounded-xl overflow-hidden h-48 lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20open%20laptop%20showing%20colorful%20data%20charts%20and%20product%20images%2C%20surrounded%20by%20small%20decorative%20plants%20and%20minimal%20stationery%2C%20bright%20natural%20daylight%2C%20fresh%20modern%20workspace%20aesthetic%2C%20warm%20beige%20tones&width=400&height=300&seq=whatis-img-1&orientation=landscape"
              alt="Kakobuy Spreadsheet organizacja"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-48 lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Hands%20typing%20on%20keyboard%20with%20smartphone%20and%20shopping%20bags%20in%20background%2C%20modern%20online%20shopping%20concept%2C%20warm%20cozy%20indoor%20setting%20with%20fairy%20lights%2C%20soft%20focus%20lifestyle%20photography%2C%20golden%20hour%20lighting&width=400&height=300&seq=whatis-img-2&orientation=landscape"
              alt="Kakobuy zakupy online"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-48 lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Flat%20lay%20photography%20of%20fashion%20accessories%20including%20watch%20sunglasses%20and%20wallet%20arranged%20on%20white%20marble%20surface%20with%20eucalyptus%20leaves%2C%20minimal%20elegant%20composition%2C%20overhead%20shot%2C%20soft%20diffused%20lighting&width=400&height=300&seq=whatis-img-3&orientation=landscape"
              alt="Kakobuy produkty lifestyle"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70 bg-background-50">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-secondary-100/80">
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Metoda</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Czas wyszukiwania</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Organizacja</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-800 whitespace-nowrap">Ryzyko</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-background-200/70">
                <td className="px-5 py-3.5 text-foreground-700">Google Search</td>
                <td className="px-5 py-3.5 text-foreground-600">30-60 minut</td>
                <td className="px-5 py-3.5 text-foreground-600">Brak organizacji</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-medium">
                    <i className="ri-error-warning-line"></i> Wysokie
                  </span>
                </td>
              </tr>
              <tr className="border-t border-background-200/70">
                <td className="px-5 py-3.5 text-foreground-700">Marketplace Search</td>
                <td className="px-5 py-3.5 text-foreground-600">20-40 minut</td>
                <td className="px-5 py-3.5 text-foreground-600">Podstawowa</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-500 font-medium">
                    <i className="ri-error-warning-line"></i> Średnie
                  </span>
                </td>
              </tr>
              <tr className="border-t border-background-200/70">
                <td className="px-5 py-3.5 text-primary-700 font-semibold">Kakobuy Spreadsheet</td>
                <td className="px-5 py-3.5 text-primary-600 font-medium">5-10 minut</td>
                <td className="px-5 py-3.5 text-primary-600">Pełna organizacja</td>
                <td className="px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-primary-600 font-medium">
                    <i className="ri-shield-check-line"></i> Niskie
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}